import { DateTime } from 'luxon';

const getCurrentFiscalEntity = (
  fiscalEntities: FixedPeriods.BaseFiscalPeriod[],
  date?: DateTime,
) => {
  const currentDate = date ? date.toISODate() : DateTime.now().toISODate();

  return fiscalEntities.find((entity) => {
    return currentDate >= entity.startDate && currentDate <= entity.endDate;
  });
};

export default getCurrentFiscalEntity;
